/* CORE & THIRD PARTY IMPORTS */
import { NgModule } from '@angular/core';
import { ChartsModule } from 'ng2-charts';
import { CurrencyMaskConfig, CURRENCY_MASK_CONFIG } from 'ng2-currency-mask/src/currency-mask.config';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { HttpModule } from '@angular/http';
import { BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { NoopAnimationsModule} from '@angular/platform-browser/animations';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { FlexLayoutModule } from '@angular/flex-layout';
import { CurrencyMaskModule } from 'ng2-currency-mask';


/**** SERVICES */
import {AuthService} from './app-services/auth.service';
import { NetworthService } from './app-services/networth.service';
import { BudgetService } from './app-services/budget.service';
import { GoalService } from './app-services/goal.service';
import { AnalyticsService } from './app-services/analytics.service';
import { FacebookPixelEventTrackerService } from './app-services/facebookpixeleventtracker.service';
import { UserService } from './app-services/user.service';
import { ActionsService } from './app-services/actions.service';
import { AreYouSureService } from './app-services/are-you-sure.service';
import { FeedService } from './app-services/feed.service';

/**** COMPONENTS & CREATED MODULES **/
import { AppRoutingModule } from './/app-routing.module';
import { AppCommonModule } from './app-common.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';
import { LandingpageComponent } from './landingpage/landingpage.component';
import { ForgotComponent } from './forgot/forgot.component';
import { ResetpasswordComponent } from './resetpassword/resetpassword.component';
import { MyAccountComponent } from './my-account/my-account.component';
import { ContactComponent } from './contact/contact.component';
import { AreYouSureComponent } from './are-you-sure/are-you-sure.component';
import { TermsAndConditionsComponent } from './terms-and-conditions/terms-and-conditions.component';
import { CookiePolicyComponent } from './cookie-policy/cookie-policy.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { OnboardingComponent } from './onboarding/onboarding.component';
import { CommonModule } from '@angular/common';

/* CURRENCY MASK CONFIG*/
export const CustomCurrencyMaskConfig: CurrencyMaskConfig = {
    align: 'left',
    allowNegative: true,
    decimal: '.',
    precision: 0,
    prefix: '',
    suffix: '',
    thousands: ','
};

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    RegisterComponent,
    LandingpageComponent,
    ForgotComponent,
    ResetpasswordComponent,
    MyAccountComponent,
    ContactComponent,
    AreYouSureComponent,
    TermsAndConditionsComponent,
    CookiePolicyComponent,
    PrivacyPolicyComponent,
    OnboardingComponent
],
  imports: [
    CommonModule,
    AppCommonModule,
    AppRoutingModule,
    NoopAnimationsModule,
    NgCircleProgressModule.forRoot({
      // set defaults here
      radius: 100,
      outerStrokeWidth: 16,
      innerStrokeWidth: 8,
      outerStrokeColor: '#78C000',
      innerStrokeColor: '#C7E596',
      animationDuration: 300,
    })
  ],
  providers: [
    AuthService,
    NetworthService,
    BudgetService,
    GoalService,
    UserService,
    ActionsService,
    AnalyticsService,
    FacebookPixelEventTrackerService,
    AreYouSureService,
    FeedService,
    {
      provide: CURRENCY_MASK_CONFIG,
      useValue: CustomCurrencyMaskConfig
    }
  ],
  bootstrap: [AppComponent],
  entryComponents: [ ContactComponent, AreYouSureComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/mmam/angular/src/app/app.module.ts